import {InfoEntry, TFaqSection, TMetaData} from '.'

const MetaData: TMetaData = {
  title: 'Jeux en Ligne Gratuits à Jouer sans Téléchargement sur Gamezop',
  desc: 'Jouez à plus de 200 jeux en ligne gratuits sans téléchargement sur Gamezop, incluant action, aventure, arcade, puzzle, course, et bien plus. Jouez maintenant !',
}

const InfoData: InfoEntry[] = [
  {
    tag: 'h1',
    title: 'Jeux en Ligne Gratuits à Jouer',
    body: {
      text: [
        `Jouez aux meilleurs jeux en ligne gratuits sur Gamezop, sans téléchargement !
        Choisissez votre jeu préféré dans notre liste et commencez à jouer en quelques secondes. Nous avons plus de 200 jeux gratuits populaires dans différentes catégories comme action, aventure, arcade, puzzle, course, et bien plus encore. Que vous jouiez sur mobile, PC ou iOS, Gamezop a les meilleurs jeux pour vous.`,
        `Si vous vous ennuyez, Gamezop vous propose des options infinies pour vous divertir. Construisez des défenses pour stopper les ennemis, visez et tirez sur des cibles, ou sautez par-dessus des obstacles. Découvrez des jeux passionnants comme Kingdom Fight, City Cricket, Fruity Fiesta, et bien d'autres ! Nos jeux sont adaptés à tous les âges—enfants, adultes et seniors`,
        `Vous n’avez pas besoin d’un appareil haut de gamme pour jouer à ces jeux. Nos jeux fonctionnent sans installation ni téléchargement, il vous suffit d’un navigateur et d’une connexion Internet. Jouez sur ordinateur, portable, Chromebook, smartphone, tablette, et bien plus encore.`,
      ],
      list: [],
    },
    links: {
      'Kingdom Fight': {
        type: 'game',
        name: 'Kingdom Fight',
        code: 'SyfxJ3a75Cr',
      },
      'City Cricket': {
        type: 'game',
        name: 'City Cricket',
        code: 'HJP4afkvqJQ',
      },
      'Fruity Fiesta': {
        type: 'game',
        name: 'Fruity Fiesta',
        code: 'mKZZW9NXW',
      },
    },
  },
  {
    tag: 'h2',
    title: 'Quels sont les meilleurs jeux en ligne gratuits ?',
    body: {
      text: [],
      list: [
        {
          name: 'Bubble Wipeout',
          code: 'H1AN6fkwqJ7',
          type: 'game',
        },
        {
          name: 'Mahjong At Home: Scandinavian Edition',
          code: 'JVhRZNwly',
          type: 'game',
        },
        {
          name: 'Merge Mania',
          code: 'hfPOimYqY',
          type: 'game',
        },
        {
          name: 'Chef Tycoon',
          code: 'xqO4nZ6Kt',
          type: 'game',
        },
        {
          name: 'Cyberfusion',
          code: 'HJXei0j',
          type: 'game',
        },
        {
          name: 'Mafia Billiard Tricks',
          code: 'SkkV6MJD51Q',
          type: 'game',
        },
        {
          name: 'Spider Solitaire',
          code: 'B1MfIa4QCg',
          type: 'game',
        },
        {
          name: 'Basket Champs',
          code: 'S1_V6GyP5ym',
          type: 'game',
        },
        {
          name: 'Algerian Solitaire',
          code: 'rJu76zkD917',
          type: 'game',
        },
        {
          name: 'Dragon Annihilation',
          code: 'PdIZyZNAe',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'Quels sont les jeux en ligne gratuits pour jouer avec des amis ?',
    body: {
      text: [],
      list: [
        {
          name: 'Ludo with Friends',
          code: 'SkhljT2fdgb',
          type: 'game',
        },
        {
          name: 'ZUNO',
          code: 'ByQxJnp7qRB',
          type: 'game',
        },
        {
          name: 'Tic Tac Toe',
          code: 'H1WmafkP9JQ',
          type: 'game',
        },
        {
          name: 'Ludo Dash',
          code: 'SJRX12TXcRH',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'Quels sont les genres de jeux en ligne les plus populaires ?',
    body: {
      text: [],
      list: [
        {
          name: 'Crazy games',
          nameEn: 'Crazy games',
          code: '10',
          type: 'tag',
        },
        {
          name: 'Board games',
          nameEn: 'Board games',
          code: '11',
          type: 'tag',
        },
        {
          name: 'Adventure games',
          nameEn: 'Adventure games',
          code: '14',
          type: 'tag',
        },
        {
          name: 'Puzzle Games',
          nameEn: 'Puzzle games',
          code: '8',
          type: 'tag',
        },
        {
          name: 'Shooting games',
          nameEn: 'Shooting games',
          code: '2',
          type: 'tag',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: `Qu'est-ce que Gamezop ?`,
    body: {
      text: [
        `Gamezop est une plateforme de jeux clé en main qui permet aux applications et sites web d'intégrer facilement des jeux occasionnels, améliorant ainsi l'engagement des utilisateurs. Au-delà du jeu, Gamezop gère plusieurs plateformes spécialisées : Quizzop pour des quiz interactifs et des jeux de trivia, Astrozop pour des prédictions et des conseils astrologiques, Criczop pour les scores et mises à jour de cricket en direct, et Feedzop pour une agrégation d'actualités sélectionnées. Ensemble, ces plateformes offrent une gamme variée de solutions de contenu adaptées aux intérêts divers des audiences.`,
        `Avec plus de 8 000 intégrations dans plus de 70 pays, Gamezop et ses plateformes associées sont approuvées par des marques mondiales telles qu'Amazon, Samsung Internet, Snap, Tata Play, AccuWeather, et Paytm. Ces solutions augmentent non seulement l'engagement des utilisateurs, mais ouvrent également de nouvelles opportunités de revenus. L'intégration est rapide, ne prenant que 30 minutes, et permet aux applications et sites web de proposer du contenu captivant incluant des jeux, quiz, astrologie, cricket et actualités.`,
      ],
      list: [],
    },
    initalState: 'initial_open',
  },
]

const FaqData: TFaqSection = {
  headTag: 'h2',
  headTitle: 'FAQs',
  faqs: [
    {
      tag: 'h3',
      title: 'Puis-je jouer à des jeux gratuits sans téléchargement ni installation ?',
      body: ['Oui, vous pouvez jouer à des jeux gratuits sans téléchargement ni installation.'],
    },
    {
      tag: 'h3',
      title: `Dois-je m'inscrire pour jouer ?`,
      body: [
        `Non, vous n'avez pas besoin de vous inscrire pour jouer sur Gamezop.com. Vous pouvez commencer à jouer immédiatement sans aucune inscription.`,
      ],
      links: {
        'Gamezop.com': 'https://www.gamezop.com/fr',
      },
    },
    {
      tag: 'h3',
      title: `Est-il sûr de jouer à des jeux gratuits en ligne ?`,
      body: [
        `Oui, il est sûr de jouer à des jeux gratuits en ligne lorsque vous utilisez des sites fiables comme Gamezop qui mettent la sécurité des utilisateurs en priorité. Nos jeux ne nécessitent aucun téléchargement, ce qui réduit les risques de logiciels malveillants, et nous garantissons un environnement de jeu sécurisé sans compromettre votre confidentialité ou la sécurité de vos appareils.`,
      ],
    },
    {
      tag: 'h3',
      title: 'Les jeux gratuits sont-ils vraiment gratuits ?',
      body: [
        `Oui, les jeux gratuits sont réellement gratuits à jouer sur Gamezop. Cependant, ces jeux peuvent afficher des publicités pour soutenir la plateforme.`,
      ],
    },
    {
      tag: 'h3',
      title: `Existe-t-il des jeux gratuits en ligne pour les seniors ?`,
      body: [
        `Oui, nous proposons des jeux gratuits en ligne pour les seniors, comme Sudoku Classic, Solitaire Gold, Chess Grandmaster, et bien d'autres.`,
      ],
      links: {
        'Sudoku Classic': {
          type: 'game',
          name: 'Sudoku Classic',
          code: 'SJgx126Qc0H',
        },
        'Solitaire Gold': {
          type: 'game',
          name: 'Solitaire Gold',
          code: 'rkPlk2T7qAr',
        },
        'Chess Grandmaster': {
          type: 'game',
          name: 'Chess Grandmaster',
          code: 'rkAXTzkD5kX',
        },
      },
    },
  ],
}

export default {
  meta: MetaData,
  info: InfoData,
  faq: FaqData,
}
